import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    name: String,
    payload: Object,
    origin: String
  }

  connect() {
    if (!this.hasNameValue || !this.hasPayloadValue) return;

    this.postMessage({
      name: this.nameValue,
      payload: this.payloadValue,
      origin: this.originValue
    });
  }

  post(event) {
    const { name, payload } = event.params;
    this.postMessage({ name, payload });
  }

  postMessage({ name, payload, origin }) {
    if (parent) parent.postMessage({ name, payload }, origin);
  }
}